import { Component, Prop, Vue } from 'vue-property-decorator';
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import cloneObject from "@/libs/cloneObject";
import ISelectItemDefault from '@/interfaces/selects/ISelectItemDefault';
import ILandingAttributes from '@/interfaces/ILandingAttributes';

@Component({
  name: 'AttributesForm'
})
export default class AttributesForm extends Vue {

  @Prop(Object) private newAttributeItem!: ILandingAttributes;
  @Prop(Array) private attributes!: ILandingAttributes[];

  private groupNames: ISelectItemDefault[] = [
      {
          text: 'subscription',
          value: 'subscription',
      }
  ];
           
  private addNewAttribute() {
    this.attributes.push(cloneObject(this.newAttributeItem));
  }

  private removeAttribute(index:number) {
    this.attributes.splice(index, 1);
  }

  private collapseVisible(attribute:any, index:number) {
    return !attribute.id || index === 0;
  }

  private transformLabel(field:string) {
    return capitalizeFirstLetter(field);
  }

  private generateName(field:string, index:number) {
    return `${field}${index}`;
  }

  private hideFields(field:string) {
    const fields = [
        'id',
        'createdAt',
        'updatedAt',
        'landing'
    ];

    return fields.includes(field);
  }
}